import { NICKY_URLS } from './urls.constants';

export function constructTutorialUrl(targetWebsitePath: string, defaultLang: string | null): string {
  if (defaultLang === 'en') {
    return `${NICKY_URLS.ROOT}${targetWebsitePath}`;
  } else {
    return (
      NICKY_URLS.GOOGLE_AUTO_TRANSLATE_ROOT +
      NICKY_URLS.TRANSLATION_LINK.replace('{{websitePath}}', targetWebsitePath).replaceAll(
        '{{targetLanguage}}',
        defaultLang || 'pt-br',
      )
    );
  }
}
